export default [
  {
    header: 'Measurables',
    icon: 'TrendingUpIcon',
    children: [
      {
        title: 'Manage',
        route: 'measurables-manage',
      },
      {
        title: 'Tracking Code',
        route: 'measurables-tracking-code',
      }
    ],
  },
]
